import { Link, createFileRoute } from "@tanstack/react-router"
import { Building2, Heart, MailQuestion, UsersRound } from "lucide-react"

import { AdminShell } from "@/components/admin-ui"
import { getAdminSummaryFn } from "@/lib/app.functions"
import { requireAdminRoute } from "@/lib/route-guards"

export const Route = createFileRoute("/admin/")({
  loader: async () => {
    await requireAdminRoute("/admin")
    return getAdminSummaryFn()
  },
  head: () => ({
    meta: [{ title: "Operations desk · Harbor & Pine Realty" }],
  }),
  component: AdminDashboard,
})

function AdminDashboard() {
  const { user, summary } = Route.useLoaderData()
  const stats = [
    [
      Building2,
      summary.publishedProperties,
      "Published properties",
      "properties",
    ],
    [UsersRound, summary.activeUsers, "Active users", "users"],
    [MailQuestion, summary.newInquiries, "New inquiries", "inquiries"],
    [Heart, summary.savedProperties, "Saved properties", "properties"],
  ] as const

  return (
    <AdminShell
      user={user}
      eyebrow="Overview · operational pulse"
      title="Administration"
      intro="A complete fictional operations workspace backed by the same D1 records as the public catalogue and member workspace."
    >
      <div className="grid gap-px border bg-border sm:grid-cols-2 xl:grid-cols-4">
        {stats.map(([Icon, value, label, section]) => (
          <Link
            key={label}
            to="/admin/$section"
            params={{ section }}
            className="group bg-white p-5 hover:bg-secondary"
          >
            <div className="flex items-start justify-between">
              <Icon className="size-5 text-primary" />
              <span className="font-heading text-5xl font-bold">{value}</span>
            </div>
            <p className="field-label mt-8 group-hover:text-primary">{label}</p>
          </Link>
        ))}
      </div>
      <div className="field-rule mt-8 border bg-white p-6">
        <p className="field-label">Operations note</p>
        <h2 className="mt-2 font-heading text-3xl uppercase">
          Public actions arrive here
        </h2>
        <p className="mt-4 max-w-3xl text-sm leading-6 text-muted-foreground">
          Favoriting affects the summary; inquiries enter the inbox; owner
          listings join the property table; new profiles appear under users;
          newsletter submissions appear in settings. Administrative edits to
          content and catalogue records return to the public site.
        </p>
      </div>
    </AdminShell>
  )
}
